import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { SharedModule } from '@emm/shared/shared.module';
import { MenuRoutingModule } from './menu-routing.module';
import { ManagementRoutingModule } from '@emm/management/management-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {ManagementModule} from '@emm/management/management.module';
import {menuFeatureKey, menuReducers} from '@emm/menu/store/menu.reducer';
import {AttributesEffects} from '@emm/menu/services/effects/attributes.effects';
import {MenuBaseEffects} from '@emm/menu/services/effects/menu-base-effects.service';
import {ChangeSetsEffects} from '@emm/menu/services/effects/change-sets.effects';
import {ConsumerEffects} from '@emm/menu/services/effects/consumer.effects';
import {ConsumerTypesEffects} from '@emm/menu/services/effects/consumer-types.effects';
import {ItemChildrenEffects} from '@emm/menu/services/effects/item-children.effects';
import {ItemDetailEffects} from '@emm/menu/services/effects/item-detail.effects';
import {ItemsEffects} from '@emm/menu/services/effects/items.effects';
import {LocationSetTypesEffects} from '@emm/menu/services/effects/location-set-types.effects';
import {MenuLocationSetsEffects} from '@emm/menu/services/effects/menu-location-sets-effects.service';
import {SubmenusEffects} from '@emm/menu/services/effects/submenus.effects';
import {MenuAttributesComponent} from '@emm/menu/components/menu-attributes/menu-attributes.component';
import {MenuComponent} from '@emm/menu/components/menu/menu.component';
import {
    AttributesFooterComponent
} from '@emm/menu/components/menu-attributes/attributes-footer/attributes-footer.component';
import {AttributesFormComponent} from '@emm/menu/components/menu-attributes/attributes-form/attributes-form.component';
import {
    AttributesHeaderComponent
} from '@emm/menu/components/menu-attributes/attributes-header/attributes-header.component';
import {ConsumerComponent} from '@emm/menu/components/menu-filters/consumer/consumer.component';
import {MenuFiltersComponent} from '@emm/menu/components/menu-filters/menu-filters.component';
import {MenuApiService} from '@emm/menu/services/menu-api.service';
import {MenuFacadeService} from '@emm/menu/services/menu-facade.service';
import {MenuFiltersFacadeService} from '@emm/menu/services/menu-filters-facade.service';
import {MenuFormFacadeService} from '@emm/menu/services/menu-form-facade.service';
import {MenuStoreService} from '@emm/menu/services/menu-store.service';
import {MenuTreeFacadeService} from '@emm/menu/services/menu-tree-facade.service';
import {MenuTreeFacadeBasicService} from '@emm/menu/services/menu-tree-facade-basic.service';
import {
    MenuBannerComponent
} from '@emm/menu/components/menu-tree/menu-banner/menu-banner.component';
import {ItemDetailTreeComponent} from '@emm/menu/components/menu-tree/item-detail-tree/item-detail-tree.component';
import {MenuHeaderGlobalComponent} from '@emm/menu/components/menu-header-global/menu-header-global.component';
import {MenuHeaderComponent} from '@emm/menu/components/menu-tree/menu-header/menu-header.component';
import {MenuKeyHeaderComponent} from '@emm/menu/components/menu-tree/menu-key-header/menu-key-header.component';
import {MenuTreeComponent} from '@emm/menu/components/menu-tree/menu-tree.component';
import {MenuLayoutComponent} from '@emm/menu/components/menu-layout/menu-layout.component';
import {
    ItemsControlsFooterComponent
} from '@emm/menu/components/menu-tree/items-controls-footer/items-controls-footer.component';
import {NoSubmenusComponent} from '@emm/menu/components/menu-tree/no-submenus/no-submenus.component';
import {CoreModule} from '@emm/core/core.module';
import {MenuPublishingService} from '@emm/core/services/menu-publishing.service';
import {MenuSearchComponent} from '@emm/menu/components/menu-search/menu-search.component';
import {CommonItemsModule} from '@emm/common-items/common-items.module';


@NgModule({
    declarations: [
        MenuAttributesComponent,
        MenuComponent,
        AttributesFooterComponent,
        AttributesFormComponent,
        AttributesHeaderComponent,
        MenuAttributesComponent,
        ConsumerComponent,
        MenuFiltersComponent,
        MenuBannerComponent,
        ItemDetailTreeComponent,
        MenuHeaderGlobalComponent,
        MenuHeaderComponent,
        MenuKeyHeaderComponent,
        MenuTreeComponent,
        MenuLayoutComponent,
        ItemsControlsFooterComponent,
        NoSubmenusComponent,
        MenuSearchComponent
    ],
    imports: [
        SharedModule,
        MenuRoutingModule,
        StoreModule.forFeature(menuFeatureKey, menuReducers),
        EffectsModule.forFeature([MenuBaseEffects, AttributesEffects, ChangeSetsEffects,
            ConsumerEffects, ConsumerTypesEffects, ItemChildrenEffects, ItemDetailEffects,
            ItemsEffects, LocationSetTypesEffects, MenuLocationSetsEffects, SubmenusEffects]),
        ManagementRoutingModule,
        DragDropModule,
        ManagementModule,
        CoreModule,
        CommonItemsModule,
    ],
    providers: [
        MenuApiService, MenuFacadeService, MenuFiltersFacadeService,
        MenuFormFacadeService, MenuStoreService, MenuTreeFacadeService,
        MenuTreeFacadeBasicService, MenuPublishingService,
    ],
    exports: [
        MenuComponent,
        MenuLayoutComponent
    ]
})
export class MenuModule {}
